export enum SewerageOptions {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
